export default __webpack_public_path__ + "static/banner-tech-savvy-savers-69982c02f7a709142d05c9330315c329.jpg";